<template>
  <section>
    <main
      class="max-w-7xl mx-auto w-full py-6 flex flex-col gap-6 px-5 md:px-0"
    >
      <h2
        class="text-[24px] lg:text-[35px] font-semibold text-black text-left md:text-center"
      >
        Our Accreditations & Recognitions
      </h2>
      <p
        class="text-[14px] md:text-[18px] text-left md:text-center font-normal mt-[-20px]"
      >
        Here's why JAIN Online is a trusted name.
      </p>
      <div class="hidden md:block">
        <div class="gap-4 slick_recognitions md:flex md:p-[1rem]">
          <div v-for="el in ranking_list" :key="el">
            <div
              class="h-[168px] w-[155px] flex flex-col items-center justify-center shadow-md border border-gray-100 p-2 rounded-md"
            >
              <div>
                <img
                  :src="el.img"
                  :alt="el.alt"
                  class="w-[130px] h-[90px] object-contain"
                />
              </div>
              <p class="text-xs">{{ el.title }}</p>
            </div>
          </div>
        </div>
      </div>
      <!-- Mobile View -->
      <div class="md:hidden">
        <div class="slick_recognitions_mobile">
          <!-- 1st  -->
          <div class="px-5">
            <div class="flex gap-2 justify-center items-center">
              <div
                class="h-[168px] w-[155px] flex flex-col items-center justify-center shadow-lg border border-gray-100 p-1 rounded-md"
              >
                <div>
                  <img
                    src="@/assets/home/ranking/naac.webp"
                    loading="lazy"
                    decoding="async"
                    class="w-[130px] h-[90px] object-contain"
                    alt="NAAC"
                  />
                </div>
                <h2 class="text-xs line-clamp-2">
                  Accredited by NAAC with an 'A++' grade
                </h2>
              </div>

              <div
                class="h-[168px] w-[155px] flex flex-col items-center justify-center shadow-lg border border-gray-100 p-1 rounded-md"
              >
                <div>
                  <img
                    src="@/assets/home/ranking/nirf.webp"
                    loading="lazy"
                    decoding="async"
                    class="w-[130px] h-[90px] object-contain"
                    alt="NIRF"
                  />
                </div>
                <h2 class="text-xs line-clamp-2">
                  Ranked 68th among the top 100 universities by NIRF
                </h2>
              </div>
            </div>
            <div class="flex gap-2 justify-center items-center">
              <div
                class="h-[168px] w-[155px] flex flex-col items-center justify-center shadow-lg border border-gray-100 p-1 rounded-md"
              >
                <div>
                  <img
                    src="@/assets/home/ranking/aicte.webp"
                    loading="lazy"
                    decoding="async"
                    class="w-[130px] h-[90px] object-contain"
                    alt="AICTE"
                  />
                </div>
                <h2 class="text-xs line-clamp-2">
                  MBA and MCA Programs are approved by All India Council for
                  Technical Education (AICTE)
                </h2>
              </div>

              <div
                class="h-[168px] w-[155px] flex flex-col items-center justify-center shadow-lg border border-gray-100 p-1 rounded-md"
              >
                <div>
                  <img
                    src="@/assets/home/ranking/auap.webp"
                    loading="lazy"
                    decoding="async"
                    class="w-[130px] h-[90px] object-contain"
                    alt="AUAP"
                  />
                </div>
                <h2 class="text-xs line-clamp-2">
                  Member of the Association of Universities of Asia and the
                  Pacific
                </h2>
              </div>
            </div>
            <div class="flex gap-2 justify-center items-center">
              <div
                class="h-[168px] w-[150px] flex flex-col items-center justify-center shadow-lg border border-gray-100 p-1 rounded-md"
              >
                <div>
                  <img
                    src="@/assets/home/ranking/acu.webp"
                    loading="lazy"
                    decoding="async"
                    class="w-[130px] h-[90px] object-contain"
                    alt="ACU"
                  />
                </div>
                <h2 class="text-xs line-clamp-2">
                  Member of The Association of Commonwealth Universities
                </h2>
              </div>
              <div
                class="h-[168px] w-[150px] flex flex-col items-center justify-center shadow-lg border border-gray-100 p-1 rounded-md"
              >
                <div>
                  <img
                    src="@/assets/home/ranking/aiu.webp"
                    loading="lazy"
                    decoding="async"
                    class="w-[130px] h-[90px] object-contain"
                    alt="AIU"
                  />
                </div>
                <h2 class="text-xs line-clamp-2">
                  Member of Association of Indian Universities
                </h2>
              </div>
            </div>
          </div>

          <!-- 2nd  -->
          <div class="px-5">
            <div class="flex gap-2 justify-center items-center">
              <div
                class="h-[168px] w-[150px] flex flex-col items-center justify-center shadow-lg border border-gray-100 p-1 rounded-md"
              >
                <div>
                  <img
                    src="@/assets/home/ranking/wur.webp"
                    loading="lazy"
                    decoding="async"
                    class="w-[130px] h-[90px] object-contain"
                    alt="WUR"
                  />
                </div>
                <h2 class="text-xs line-clamp-2">
                  Ranked among the top Indian Universities by QS World
                  University Rankings
                </h2>
              </div>

              <div
                class="h-[168px] w-[150px] flex flex-col items-center justify-center shadow-lg border border-gray-100 p-1 rounded-md"
              >
                <div>
                  <img
                    src="@/assets/home/ranking/ksurf.webp"
                    loading="lazy"
                    decoding="async"
                    class="w-[130px] h-[90px] object-contain"
                    alt="KSURF"
                  />
                </div>
                <h2 class="text-xs line-clamp-2">
                  Awarded 5 Star Rating by Karnataka State Higher Education
                  Council under KSURF
                </h2>
              </div>
            </div>
            <div class="flex gap-2 justify-center items-center">
              <div
                class="h-[168px] w-[150px] flex flex-col items-center justify-center shadow-lg border border-gray-100 p-1 rounded-md"
              >
                <div>
                  <img
                    src="@/assets/home/ranking/careers.webp"
                    loading="lazy"
                    decoding="async"
                    class="w-[130px] h-[90px] object-contain"
                    alt="CAREERS"
                  />
                </div>
                <h2 class="text-xs line-clamp-2">
                  Secured an AAAA+ rating under Deemed Universities by
                  Careers360
                </h2>
              </div>

              <div
                class="h-[168px] w-[150px] flex flex-col items-center justify-center shadow-lg border border-gray-100 p-1 rounded-md"
              >
                <div>
                  <img
                    src="@/assets/home/ranking/ugc.webp"
                    loading="lazy"
                    decoding="async"
                    class="w-[130px] h-[90px] object-contain"
                    alt="UGC"
                  />
                </div>
                <h2 class="text-xs line-clamp-2">
                  Entitled by the University Grants Commission (UGC)
                </h2>
              </div>
            </div>
            <div class="flex gap-2 justify-left items-center">
              <div
                class="h-[168px] w-[150px] flex flex-col items-center justify-center shadow-lg border border-gray-100 p-1 rounded-md"
              >
                <div>
                  <img
                    src="@/assets/home/ranking/wes.webp"
                    loading="lazy"
                    decoding="async"
                    class="w-[130px] h-[90px] object-contain"
                    alt="WES"
                  />
                </div>
                <h2 class="text-xs line-clamp-2">
                  Accredited by WES and recognized in the USA and Canada
                </h2>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  </section>
</template>

<script>
import $ from "jquery";
import "slick-carousel";
export default {
  data() {
    return {
      ranking_list: [
        {
          title: "Accredited by NAAC with an 'A++' grade",
          img: require("@/assets/home/ranking/naac.webp"),
          alt: "NAAC",
        },
        {
          title: "Entitled by the University Grants Commission (UGC)",
          img: require("@/assets/home/ranking/ugc.webp"),
          alt: "UGC",
        },
        {
          title: "Ranked 68th among the top 100 universities by NIRF",
          img: require("@/assets/home/ranking/nirf.webp"),
          alt: "NIRF",
        },
        {
          title:
            "MBA and MCA Programs are approved by All India Council for Technical Education (AICTE)",
          img: require("@/assets/home/ranking/aicte.webp"),
          alt: "AICTE",
        },
        {
          title:
            "Ranked among the top Indian Universities by QS World University Rankings",
          img: require("@/assets/home/ranking/wur.webp"),
          alt: "WUR",
        },
        {
          title:
            "Member of the Association of Universities of Asia and the Pacific",
          img: require("@/assets/home/ranking/auap.webp"),
          alt: "AUAP",
        },
        {
          title: "Member of The Association of Commonwealth Universities",
          img: require("@/assets/home/ranking/acu.webp"),
          alt: "ACU",
        },
        {
          title: "Accredited by WES and recognized in the USA and Canada",
          img: require("@/assets/home/ranking/wes.webp"),
          alt: "WES",
        },
        {
          title: "Member of Association of Indian Universities",
          img: require("@/assets/home/ranking/aiu.webp"),
          alt: "AIU",
        },
        {
          title:
            "Secured an AAAA+ rating under Deemed Universities by Careers360",
          img: require("@/assets/home/ranking/careers.webp"),
          alt: "CAREERS",
        },
        {
          title:
            "Awarded 5 Star Rating by Karnataka State Higher Education Council under KSURF",
          img: require("@/assets/home/ranking/ksurf.webp"),
          alt: "KSURF",
        },
      ],
    };
  },
  mounted() {
    $(`.slick_recognitions_mobile`).slick({
      autoplay: true,
      prevArrow: false,
      nextArrow: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: true,
      dotsClass: "slick-dots",
    });

    $(`.slick_recognitions`).slick({
      autoplay: true,
      prevArrow: false,
      nextArrow: false,
      slidesToShow: 6,
      slidesToScroll: 1,
      dots: true,
      dotsClass: "slick-dots",

      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 6,
            slidesToScroll: 6,
          },
        },
        {
          breakpoint: 950,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 4,
          },
        },
        {
          breakpoint: 650,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 4,
          },
        },
        {
          breakpoint: 420,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
          },
        },
      ],
    });
  },
};
</script>

<style></style>
